import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
// import {createStore } from 'redux'
import { applyMiddleware, createStore } from 'redux'
import createSagaMiddleware from 'redux-saga'
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import rootReducer from './store/reducer/rootReducer'
import saga from './component/saga/saga.js'

const sagaMiddleware = createSagaMiddleware();
const store = createStore(
  rootReducer,
  applyMiddleware(sagaMiddleware))

sagaMiddleware.run(saga)

// const store = createStore(rootReducer)

ReactDOM.render(
  <Provider store={store}><App /></Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
